import React from "react";
import Seo from "../seo/Seo";
import { BookButton } from "../components/CtaPair";
import "../styles/Dimop.css";

// Hungarian-only landing page for the DIMOP Plusz-1.2.3/A-24 call.
//
// The copy below was supplied by Viktor and is used VERBATIM. It is deliberately
// not in the locale files: this page has one language, must not be translated,
// and must not drift. Do not reword it without asking.
//
// The route exists only for /hu (DIMOP_ENABLED in src/config/flags.js), and the
// SEO tags declare Hungarian as its only language.

const MFB_URL =
  "https://www.mfb.hu/vallalkozasok/mikro/hitel/dimop-plusz--123a-24-mikro--kis--es-kozepvallalkozasok-digitalizaciojanak-tamogatasa-egymuveletes-kombinalt-hiteltermek-kereteben-t225-p225";

const BLOCKS = [
  {
    q: "Mit kap a vállalkozása?",
    a: ["0%-os fix kamatozású hitelt 3–20 millió forint között, amelynek legfeljebb 50%-a vissza nem térítendő támogatás."],
  },
  {
    q: "Mire fordítható?",
    a: [
      "A felhívás kifejezetten támogatja a mesterséges intelligencia technológiák és szolgáltatások bevezetését, köztük az MI-alapú folyamat-automatizációt, a szövegbányászatot, valamint a kép- és beszédfelismerést.",
      "Például: a beérkező számlák, szállítólevelek és megrendelések automatikus feldolgozása, vagy egy MI-asszisztens a cég saját dokumentumai fölött.",
    ],
  },
  {
    q: "Kinek szól?",
    a: ["Magyarországi mikro-, kis- és középvállalkozásoknak, amelyek digitális intenzitása ma nagyon alacsony vagy alacsony, és a projekt végére legalább egy szintet lépnek előre."],
  },
  {
    q: "Meddig?",
    a: ["A kérelmek 2027. június 30-ig nyújthatók be."],
  },
  {
    q: "Miben segítünk?",
    a: ["Egy egyhetes, ingyenes próbaprojekttel megmutatjuk, mit automatizálna az MI az Ön egyik folyamatában. Elkészítjük a kérelemhez szükséges műszaki tartalmat és árajánlatot, a jóváhagyás után pedig megvalósítjuk és üzemeltetjük a rendszert."],
  },
];

const Dimop = () => (
  <div className="dimop-page">
    <Seo
      page="dimop"
      path="/dimop"
      override={{
        languages: ["hu"],
        title: "MI-alapú folyamat-automatizálás DIMOP Plusz támogatással",
        description:
          "0%-os fix kamatozású hitel 3–20 millió forint között MI-alapú folyamat-automatizációra; legfeljebb 50%-a vissza nem térítendő támogatás.",
      }}
    />

    <section className="dimop-hero">
      <div className="container">
        <span className="dimop-badge">DIMOP Plusz-1.2.3/A-24</span>
        <h1>AI-alapú folyamat-automatizálás DIMOP Plusz-1.2.3/A-24 támogatással</h1>
      </div>
    </section>

    <section className="dimop-body">
      <div className="container">
        {BLOCKS.map((block) => (
          <div className="dimop-block" key={block.q}>
            <h2>{block.q}</h2>
            {block.a.map((p) => (
              <p key={p}>{p}</p>
            ))}
          </div>
        ))}

        <div className="dimop-cta">
          <p className="dimop-team">
            Magyar anyanyelvű csapatunk Adán, a határ közelében dolgozik, és szívesen személyesen is felkeressük.
          </p>
          <BookButton />
        </div>

        <p className="dimop-disclaimer">
          <a href={MFB_URL} target="_blank" rel="noopener noreferrer">
            A részletes feltételeket a felhívás és az MFB tájékoztatója tartalmazza; a jogosultságot a kérelem benyújtása előtt közösen ellenőrizzük.
          </a>
        </p>
      </div>
    </section>
  </div>
);

export default Dimop;
